import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import OfferteForm from './components/OfferteForm';

const Offerte = () => {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Gratis Offerte Aanvragen – NGP Renovatieproject",
      "url": `${import.meta.env.VITE_SITE_URL ?? ''}/offerte`,
      "description": "Vraag gratis en vrijblijvend een offerte aan voor uw renovatieproject in Antwerpen en omgeving. Reactie binnen 24 uur.",
      "provider": {
        "@type": "LocalBusiness",
        "name": "NGP Renovatieproject",
        "email": "ngp.renovatieprojecten@gmail.com",
        "telephone": "+3210231886",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Adelaarstraat 55 B301",
          "addressLocality": "Merksem",
          "postalCode": "2170",
          "addressCountry": "BE"
        }
      },
      "areaServed": {
        "@type": "City",
        "name": "Antwerpen"
      },
      "serviceType": ["Renovatie", "Badkamer verbouwing", "Keuken renovatie", "Appartement renovatie"],
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "EUR",
        "description": "Gratis en vrijblijvende offerte op maat"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-offerte';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('schema-offerte');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-gray-50 pt-28 pb-20">
        {/* Hero */}
        <section className="bg-gray-900 text-white py-16 mb-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
            <p className="text-sm font-medium tracking-widest uppercase text-gray-400 mb-3">
              Gratis &amp; Vrijblijvend
            </p>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Vraag een Offerte Aan
            </h1>
            <p className="text-gray-300 text-lg max-w-xl mx-auto">
              Vertel ons over uw renovatieproject en ontvang binnen 24 uur een persoonlijke offerte op maat.
            </p>
          </div>
        </section>

        {/* Form + Info */}
        <section className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Form */}
            <div className="lg:col-span-2">
              <OfferteForm />
            </div>

            {/* Sidebar info */}
            <div className="space-y-6">
              <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
                <h3 className="text-base font-semibold text-gray-900 mb-4">Waarom NGP kiezen?</h3>
                <ul className="space-y-3">
                  {[
                    { icon: 'ri-shield-check-line', text: 'Gratis en vrijblijvende offerte' },
                    { icon: 'ri-time-line', text: 'Reactie binnen 24 uur' },
                    { icon: 'ri-medal-line', text: 'Meer dan 10 jaar ervaring' },
                    { icon: 'ri-map-pin-line', text: 'Actief in Antwerpen & omgeving' },
                    { icon: 'ri-thumb-up-line', text: '100% klanttevredenheid' },
                  ].map((item) => (
                    <li key={item.text} className="flex items-center gap-3 text-sm text-gray-600">
                      <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-full shrink-0">
                        <i className={`${item.icon} text-gray-700`}></i>
                      </div>
                      {item.text}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-gray-900 text-white rounded-2xl p-6">
                <h3 className="text-base font-semibold mb-3">Direct contact</h3>
                <p className="text-gray-400 text-sm mb-4">Liever direct bellen of mailen?</p>
                <div className="space-y-3">
                  <a
                    href="tel:+3210231886"
                    className="flex items-center gap-3 text-sm text-gray-200 hover:text-white transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full">
                      <i className="ri-phone-line"></i>
                    </div>
                    +32 10 23 18 86
                  </a>
                  <a
                    href="mailto:ngp.renovatieprojecten@gmail.com"
                    className="flex items-center gap-3 text-sm text-gray-200 hover:text-white transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full">
                      <i className="ri-mail-line"></i>
                    </div>
                    ngp.renovatieprojecten@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Offerte;